import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cui-offline-indicator',
  templateUrl: './offline-indicator.component.html',
  styleUrls: ['./offline-indicator.component.scss']
})
export class CuiOfflineIndicatorComponent implements OnInit {
  @Input()
  offline: string;

  @Input()
  online: string;

  @Input()
  duration = 4000;

  isOfflineShown = false;
  isOnlineShown = false;

  private msgTimeout: number;

  ngOnInit() {
    window.addEventListener('online', () => this.showOnline());
    window.addEventListener('offline', () => this.showOffline());
  }

  showOnline() {
    this.isOfflineShown = false;
    this.isOnlineShown = true;

    window.clearTimeout(this.msgTimeout);

    this.msgTimeout = window.setTimeout(() => this.isOnlineShown = false, this.duration);
  }

  showOffline() {
    this.isOnlineShown = false;
    this.isOfflineShown = true;
  }

}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/offline-indicator/offline-indicator.component.ts